import useStore from "./useStore";

export const createQuestionSlice = (set) => ({
  questionId: 0,
  questionCreatorId: 0,
  isSelectedQuestion: false,
  setQuestionId: (id) => set(() => ({ questionId: id })),
  setQuestionCreatorId: (id) => set(() => ({ questionCreatorId: id })),
  selectAQuestion: (state) =>
    set(() => ({
      isSelectedQuestion: state === true || state === false ? state : false,
    })),
});

export const useIsSelectedQuestion = () => useStore((state) => state.isSelectedQuestion);
export const useQuestionId = () => useStore((state) => state.questionId);
export const useSetQuestionId = () => useStore((state) => state.setQuestionId);

export const useSelectAQuestion = () => useStore((state) => state.selectAQuestion);
export const useSetQuestionCreatorId = () => useStore((state) => state.setQuestionCreatorId);
export const useQuestionCreatorId = () => useStore((state) => state.questionCreatorId);
